<template>
  <div class="care-detail" :type="type">
    <y-panel-msg title="提交成功" :content="content" :ico="require('@/assets/login-success.png')"></y-panel-msg>
    <template v-if="service && service.length > 1">
      <div class="service-title">
        尊享<span>{{ ((service && service.length) || "0") + "项" }}</span
        >服务权益
      </div>
      <div class="service-layout">
        <div
          class="item"
          v-for="(item, index) in service"
          :key="'service-i-' + index"
        >
          <img :src="item.icon" />
          <div class="name">{{ item.name }}</div>
          <div class="total">{{ item.total + item.unit }}</div>
        </div>
      </div>
    </template>
    <div v-else-if="service" class="single-service-info">
      <img :src="service[0].icon2" />
      <div class="name">{{ service[0].name }}</div>
      <div class="info">{{ service[0].info }}</div>
    </div>
    <div class="steps">
      <div class="step"><span>提交资料</span></div>
      <div class="line"></div>
      <div class="step"><span>等待审核</span></div>
      <div class="line"></div>
      <div class="step"><span>激活成功</span></div>
    </div>
    <div class="bottom">
      <!-- <div class="msg">客服正在处理您的无忧卡激活，请耐心等待</div> -->
      <div class="con">
        <a class="service-call" href="javascript:void(0)" @click="goto('KF_SERVICE')">
          <span><img src="@/assets/service-call.png" alt="service call" /></span>
          <span>客服</span>
        </a>
        <y-button class="btn" @click="gotoDetail()">查看卡片</y-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Progress } from "vant";
import { httpOpen } from "../../scripts/network";
Vue.use(Dialog);
Vue.use(Progress);

export default {
  name: "ActiveSubmitSuccess",
  data() {
    return {
      id: "",
      type: 1,
      care: null,
      phone: this.$store.state.userInfo && this.$store.state.userInfo.phone,
      serviceBase: {
        "1": {
          name: "免费贴膜",
          icon: require("../../assets/ic_sticker.png"),
          icon2: require("../../assets/ic_sticker.png"),
          type: 1,
          use: 0,
          total: 0,
          unit: "次"
        },
        "2": {
          name: "电池更换",
          icon: require("../../assets/ic_battery.png"),
          icon2: require("../../assets/ic_battery2.png"),
          type: 2,
          use: 0,
          total: 0,
          unit: "次"
        },
        "3": {
          name: "屏幕更换",
          icon: require("../../assets/ic_screen.png"),
          icon2: require("../../assets/ic_screen2.png"),
          type: 3,
          use: 2,
          total: 0,
          unit: "次"
        },
        "4": {
          name: "整机质保",
          icon: require("../../assets/ic_insurance.png"),
          icon2: require("../../assets/ic_insurance2.png"),
          type: 4,
          use: 0,
          total: 0,
          unit: "年"
        },
          "5": {
              name: "后壳更换",
              icon: require("../../assets/card-qy-type-5.png"),
              icon2: require("../../assets/card-qy-type-5.png"),
              type: 5,
              use: 0,
              total: 0,
              unit: "次"
          }
      },
      service: null
    };
  },
  computed: {
    content() {
      return "激活成功后，将发送短信至「" + this.phone + "」 可通过短信内链接进行权益查看";
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.loadDetail();
  },
  methods: {
    filterService(service, type) {
      return service.filter(
        element => element.supportTypes.findIndex(t => t === type) !== -1
      );
    },
    async loadDetail() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: this.id }
        });
        if (ret.Status) {
          this.care = this.careCardResultMapper(ret.Data);
          // this.service = ret.Data.OrderEquityList.map(this.serviceMapper); // 新版UI无权益项列表
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    careCardResultMapper(data) {
      return {
        id: data.sysNo,
        type: data.ServiceType,
        endTime: new Date(
          data.FailureTime && data.FailureTime + "+08:00"
        ).format("yyyy-MM-dd"),
        name:data.ServiceTypeName,
        imei: data.IMEICode,
        status: data.CardStatus,
        audit: data.AuditStatus
      };
    },
    serviceMapper(item) {
      let service = this.serviceBase[item.EquityType];
      if(!service) {
        service = { name:item.EquityTypeName, unit:'次' };
      }
      service.type = item.EquityType;
      service.use = item.UseTotalNum;
      service.total = service.type !== 4 ? item.EquityTotalCount : 2;
      service.info =
        service.type !== 4
          ? `已使用${service.use}${service.unit} 共${service.total +
              service.unit}`
          : "保护中";
      return service;
    },
    gotoDetail() {
          this.$router.push("/care/" + this.$route.params.id);
      }
  }
};
</script>

<style lang="less">
.care-detail {
  padding: 16px;
  min-height: 100vh;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  background: #f4f4f4;

  .service-title {
    color: white;
    font-size: 16px;
    margin: 14px 0 0 8px;
  }
  .service-layout {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 16px;
    min-height: 60px;
    margin-bottom: 16px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      * + * {
        margin-top: 4px;
      }
      img {
        width: 22px;
        height: 30px;
      }
      .name {
        color: white;
      }
      .total {
        color: #e6c587;
      }
    }
  }
  .single-service-info {
    display: flex;
    align-items: center;
    margin: 20px 0;
    font-size: 14px;
    padding: 0 10px;
    img {
      width: 20px;
      padding-right: 4px;
    }
    .name {
      color: white;
    }
    .info {
      color: white;
      flex: 1 1;
      text-align: right;
    }
  }
  .steps {
    display: flex;
    flex-direction: row;
    margin: 16px 24px;
    font-size: 14px;
    color: #000;
    padding-top: 20%;
    .line {
      flex: 1 1;
      height: 7px;
      margin: 10px 4px;
      background: rgba(241,220,197,0.33);
    }
    .step {
      counter-increment: step;
      font-size: 14px;
      span{
        padding-top: 5px;
        display: inline-block;
      }
    }
    .step::before {
      content: counter(step);
      display: block;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      width: 24px;
      height: 24px;
      line-height: 24px;
      background: linear-gradient(180deg,#f4e0c9, #ceab8b);
      border-radius: 100%;
      margin:0 auto;
    }
  }
  .bottom{
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .msg{
      background-color: #FFF7EB;
      padding: 9px 0;
      text-align: center;
      font-size: 14px;
      color: #4d3621;
    }
    .con{
      padding: 7px 23px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .service-call {
        display: flex;
        width: 54px;
        height: 54px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #4F4F4F;
        padding: 0 10px;
        img {
          width: 17px;
          height: 18px;
        }
      }
      .btn{
        flex: 1 1;
      }
    }
  }
}
</style>